import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {path:'*', redirect: '/'}, 
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta:{
      title:"e法豫同行 护航新征程",
      keepAlive: true  // 需要缓存
    }
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta:{
      title:"e法豫同行 护航新征程",
      keepAlive: true  // 需要缓存
    }
  },
  {
    path: '/404',
    name: '404',
    component: () => import(/* webpackChunkName: "404" */ '../views/404.vue'),
    meta:{
      title:"e法豫同行 护航新征程",
      keepAlive: false  // 需要缓存
    }
  },
  {
    path: '/bm',
    name: 'Bm',
    component: () => import(/* webpackChunkName: "Bm" */ '../views/Bm.vue'),//报名
    meta:{
      title:"收货地址"
    }
  },
  {
    path: '/dt',
    name: 'Dt',
    component: () => import(/* webpackChunkName: "Dt" */ '../views/Dt.vue'),//答题
    meta:{
      title:"答题挑战"
    }
  },
  {
    path: '/dtend',
    name: 'Dtend',
    component: () => import(/* webpackChunkName: "Dtend" */ '../views/Dtend.vue'),//答题结束
    meta:{
      title:"答题结束"
    }
  },
]

// 解决报错
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace

VueRouter.prototype.push = function push (location, onResolve, onReject) {
  console.log(onReject + onResolve)
// if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
return originalPush.call(this, location).catch(err => {
    console.log(err)
    originalPush.call(this, location, onResolve, onReject)
});
}
// replace
VueRouter.prototype.replace = function push (location, onResolve, onReject) {
  console.log(onReject + onResolve)
// if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
return originalReplace.call(this, location).catch(err => {
    console.log(err)
    originalPush.call(this, location, onResolve, onReject)
})
}

const router = new VueRouter({
  mode: 'hash',
  scrollBehavior: (to) => ({
    x:0,
    y: 0
  }),
  routes
})
router.beforeEach((to, from, next) => {
  document.title=to.meta.title || "e法豫同行 护航新征程"
  next()
})

export default router
